var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamLabel = exports.TransferDuration = exports.PlayerJoinDate = exports.PlayerLoan = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Transfers/TransferComponents.js";

var PlayerLoan = function PlayerLoan(_ref) {
  var loan = _ref.loan;
  return loan === 'LOAN_START' ? _react.default.createElement(_Basic.Text, {
    size: "small",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 29
    }
  }, (0, _i18n.default)('transfer.LOAN')) : null;
};

exports.PlayerLoan = PlayerLoan;

var PlayerJoinDate = function PlayerJoinDate(_ref2) {
  var joinDate = _ref2.joinDate;
  return joinDate ? _react.default.createElement(_Basic.Text, {
    size: "small",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 16
    }
  }, (0, _moment.default)(joinDate).format('DD-MM-YYYY')) : null;
};

exports.PlayerJoinDate = PlayerJoinDate;

var TransferDuration = function TransferDuration(_ref3) {
  var joinDate = _ref3.joinDate,
      leaveDate = _ref3.leaveDate,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["joinDate", "leaveDate"]);

  if (joinDate && leaveDate) {
    return _react.default.createElement(_Basic.View, (0, _extends2.default)({}, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17,
        columnNumber: 13
      }
    }), _react.default.createElement(_Basic.Text, {
      size: "small",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 17
      }
    }, (0, _moment.default)(joinDate).format('MM/YYYY'), " - ", (0, _moment.default)(leaveDate).format('MM/YYYY')));
  } else if (joinDate) {
    return _react.default.createElement(_Basic.View, (0, _extends2.default)({}, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 13
      }
    }), _react.default.createElement(_Basic.Text, {
      size: "small",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 17
      }
    }, (0, _i18n.default)('transfer.SINCE'), " ", (0, _moment.default)(joinDate).format('MM/YYYY')));
  }

  return null;
};

exports.TransferDuration = TransferDuration;

var TeamLabel = function TeamLabel(_ref4) {
  var team = _ref4.team,
      teamName = _ref4.teamName,
      doFallback = _ref4.doFallback,
      grow = _ref4.grow,
      maxWidth = _ref4.maxWidth,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["team", "teamName", "doFallback", "grow", "maxWidth"]);

  if (team) {
    return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
      flexing: true,
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      overflow: "hidden"
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 13
      }
    }), _react.default.createElement(_Logos.TeamLogo, {
      mr: 2,
      my: 0,
      size: 17,
      src: team.imageUrl,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 17
      }
    }), team.name ? _react.default.createElement(_Basic.View, {
      flexing: true,
      overflow: "hidden",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 21
      }
    }, _react.default.createElement(_Basic.Text, {
      flexing: true,
      numberOfLines: 1,
      bold: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 25
      }
    }, teamName || team.name)) : null);
  } else if (doFallback) {
    return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
      centerHorizontal: true
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 13
      }
    }), _react.default.createElement(_FontelloIcon.default, {
      mr: 2,
      name: "x",
      size: 17,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 17
      }
    }), _react.default.createElement(_Basic.Text, {
      numberOfLines: 1,
      bold: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 17
      }
    }, (0, _i18n.default)('transfer.NO_CLUB')));
  }

  return null;
};

exports.TeamLabel = TeamLabel;